// ==========================================================================
// Plyr supported types and providers
// ==========================================================================

export const providers = {
    html5: 'html5',
    youtube: 'youtube',
    vimeo: 'vimeo',
};

export const types = {
    audio: 'audio',
    video: 'video',
};

export default { providers, types };
